<ng-container *ngIf="loading">
  <div class="f-content">
    <img src="./assets/images/loading.gif" alt="loading" class="img-mfe">
  </div>
</ng-container>

<div [id]="elContainerName"></div>
